import bitcasino from "@workspace/casino_config/siteConfigs/bitcasino";
import DeviceType from "@workspace/nextjs_utils/src/DeviceType";
import { createContext } from "react";

const AppContext = createContext<AppContextProps>({
  site: "bitcasino",
  brand: "bitcasino",
  brandLogos: {},
  pathPrefix: "",
  translations: {},
  params: {},
  language: "en",
  languages: ["en"],
  countryCode: "EE",
  domain: "",
  sidebarItems: { common: [] },
  sidebarProviders: [],
  sidebarSections: [],
  userAgentData: {
    userAgent: "",
    isCrawler: false,
    isDesktop: false,
    isTablet: false,
    isMobile: true,
    isSafari: false,
    isChrome: false,
    isIOS: false,
    deviceType: DeviceType.ANDROID_PHONE,
  },
  siteConfig: bitcasino,
  featureFlags: {},
  telegramAPI: {},
});

export default AppContext;
